// src/components/AdsHeader.jsx
import React from "react";
import AdsAlarm from "./AdsAlarm";
import { useNavigate } from "react-router-dom";
import Calender from "../../assets/icons/Header/calendar.svg";

const AdsHeader = ({ data, tab }) => {
  const navigate = useNavigate();

  const titleByTab = {
    home: data?.store_name || "",
    reserve: "업로드 예약",
    report: "AI 리포트",
    mypage: "마이페이지",
  };
  const title = titleByTab[tab] ?? "";

  // reserve 탭일 때는 HeaderIconL 사용
  if (tab === "reserve") {
    return (
      <></>
    );
  }

  if (tab === "mypage") {
    return (
      <></>
    );
  }

  // 나머지 탭은 기존 헤더 유지
  return (
    <div
      className="
        relative w-full
        px-[16px] py-[12px]
        select-none
      "
      style={{ WebkitTextSizeAdjust: "100%", textSizeAdjust: "100%" }}
    >
      <div
        className="
          flex justify-between items-center w-full
          pt-[8px]
          gap-[12px]
          min-h-[56px]
        "
      >
        {/* 왼쪽: (메뉴버튼 자리) + 타이틀 */}
        <div className="flex items-center gap-[12px] min-w-0">
          <div className="flex flex-col justify-center min-w-0">
            <p
              className="
                text-[20px] leading-[24px] font-semibold text-black
                whitespace-nowrap overflow-hidden text-ellipsis
                max-w-[68vw]
              "
              style={{ WebkitTextSizeAdjust: "100%", textSizeAdjust: "100%" }}
              title={title}
            >
              {title}
            </p>
          </div>
        </div>

        {/* 오른쪽: 캘린더 + 알림 아이콘 */}
        <div className="flex items-center gap-[16px] z-10 pr-[4px] shrink-0">
          <button
            className="flex items-center z-10"
            onClick={() => {
              navigate(`/mycalendar`, { state: { data: data, tab: tab } });
            }}
            type="button"
          >
            <img
              src={Calender}
              alt="달력 아이콘"
              className="object-contain shrink-0"
              draggable={false}
            />
          </button>
          <div className="flex items-center z-10 shrink-0">
            <AdsAlarm data={data} currentTab={tab} />
          </div>
        </div>
      </div>

    </div>
  );
};

export default AdsHeader;
